import {
  IrRow,
  CalculationRowType,
  Unit,
  IncomeTypesLogic,
  Language,
  EnumerationsLogic,
} from "@salaxy/core";

import { ICalculationReportRowData } from "./ICalculationReportRowData";
import { ICalculationTableRowDataInput } from "./ICalculationTableRowDataInput";

/** Row data for worker and employer calculation tables. */
export class CalculationTableRowData implements ICalculationReportRowData {

  /** Ir row. */
  public irRow: IrRow = {};

  /** Full total for the row. For example the original calculated version. */
  public fullTotal?: number;

  /** Returns true if there is no enough money to pay the calculated amount. */
  public isTotalReduced?: boolean;
  private _comment: string | undefined = undefined;


  /** Constructor for creating row. */
  constructor(data: ICalculationTableRowDataInput, lang?: Language) {
    if (!data) {
      return;
    }
    this.fullTotal = data.fullTotal;
    this.comment = data.comment;
    this.irRow = data.irRow || {};
    if (!this.irRow.message) {
      let rowType = this.irRow.data?.calculationRowType || CalculationRowType.Unknown;
      rowType = (rowType.substr(0, 1).toLowerCase() + rowType.substr(1)) as CalculationRowType;
      const code = this.irRow.irData?.code as number;
      const kind = this.irRow.data?.kind as string;

      let label: string | undefined = "";
      if (rowType === CalculationRowType.IrIncomeType) {
        label = IncomeTypesLogic.getAll(lang).find( (x) => (kind && x.transactionCode === kind) || (code > 0 && x.code === code))?.label;

      } else if (rowType === CalculationRowType.MealBenefit && code !== 334) {
        // Meal benefit deductions
        label = IncomeTypesLogic.getAll(lang).find( (x) => code > 0 && x.code === code)?.label;
      } else if([
        CalculationRowType.Unknown,
        CalculationRowType.CarBenefit,
        CalculationRowType.BicycleBenefit,
        CalculationRowType.SubsidisedCommute,
        CalculationRowType.TaxAtSource,
        CalculationRowType.HourlySalaryWithWorkingTimeCompensation
      ].includes(rowType))
      {
        label = IncomeTypesLogic.getAll(lang).find( (x) => code > 0 && x.code === code)?.label;
      }
      else if([
        CalculationRowType.DailyAllowance,
        CalculationRowType.EmploymentTermination,
        CalculationRowType.WorkingTimeCompensation,
        CalculationRowType.Remuneration,
        CalculationRowType.OtherCompensation,
        CalculationRowType.NonProfitOrg,
        CalculationRowType.MealBenefit, // main MealBenefit
        CalculationRowType.Training,
        CalculationRowType.PaidSickLeave,
        CalculationRowType.TimeRatePay,
      ].includes(rowType) && kind) {
        label =  EnumerationsLogic.getEnumLabel(`${this.irRow.data?.calculationRowType}Kind`, kind, undefined, lang);
      }
      this.irRow.message = label || EnumerationsLogic.getEnumLabel("CalculationRowType", rowType, undefined, lang);
    }
    this.isTotalReduced = data.isTotalReduced;
  }

  /** Total amount. */
  public get total(): number { return this.irRow.total || 0; }

  /** Total amount. */
  public set total(value: number) { this.irRow.total = value; }

  /** Returns true if the unit is percentage */
  public get isUnitPercent(): boolean { return this.irRow.unit === Unit.Percent; }

  /** Row further information. */
  public get comment(): string | undefined {
    if (this._comment) {
      return this._comment;
    }

    if (this.irRow.data != null && this.irRow.data.sxySalarySlipRowComment) {
      return this.irRow.data.sxySalarySlipRowComment;
    }
    return undefined;
  }

  /** Row further information. */
  public set comment(value: string | undefined) { this._comment = value; }

  private getEnum<T>(value: any): T {
    if (!value) {
      return value;
    }
    let str = `${value as string}`;
    str = str.charAt(0).toLowerCase() + str.slice(1);
    return str as any as T;
  }

}
